import { render, staticRenderFns } from "./lrLinkable.vue?vue&type=template&id=4684c45a&"
import script from "./lrLinkable.vue?vue&type=script&lang=js&"
export * from "./lrLinkable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports